module.exports = __webpack_public_path__ + "static/media/cloudy.3f734f8e.webp";